import * as React from 'react';
import {FormattedMessage} from 'react-intl';

import {EpiImage} from "features/search/types";
import {IContentBlock} from 'features/blocks/types';
import {ImageSizes} from '@organisms/Shell/image-size-enum';
import {HeadlineLevel, Margin} from 'features/ui/enums';
import {isExternalUrl} from 'features/services/utils/url-helper';
import {useDeviceStore, selectIsMobile, selectIsTablet} from 'features/ui/store/useDeviceStore';

import 'components/blocks/Headers/CampaignHeaderBlock/style.scss';

import {P} from '@atoms/Text/P';
import {Icon} from '@atoms/Media/Icon';
import { Headline } from '@atoms/Text/Headline';
import {AsyncImage} from '@atoms/Media/AsyncImage';
import {ButtonLink} from '@atoms/LinksAndButtons/ButtonLink';
import { ButtonColor, ButtonSize, ButtonType } from '@atoms/LinksAndButtons/Button';

export interface CampaignHeaderBlockType {
    heroImage: EpiImage;
    title: string;
    preamble: string;
    bulletList: string[];
    bulletListIntro: string;
    buttonLink: string;
    buttonText: string;
    internalLink: boolean;
}

type Props = IContentBlock<CampaignHeaderBlockType>;

export const CampaignHeaderBlock: React.FunctionComponent<Props> = (props) => {

    const isMobile = useDeviceStore(selectIsMobile);
    const isTablet = useDeviceStore(selectIsTablet);

    if(!props.data.heroImage || props.data.heroImage === null) return null;
    return (
        <div className="campaign-header-block" id={props.id}>
            <div className="campaign-header-block__image">
                <div className="campaign-header-block__image__wrapper">
                    <AsyncImage
                        //alt={props.data.title}
                        fullHeight={isMobile}
                        fullWidth={!isMobile}
                        headerImage
                        image={props.data.heroImage}
                        quality={ImageSizes.SIZE_2560}
                    />
                </div>
            </div>

            {props.data.title &&
                <div className="campaign-header-block__text">
                    <Headline
                        level={HeadlineLevel.H1}
                        margin={isMobile && !isTablet ? Margin.S : undefined}
                    >
                        {props.data.title}
                    </Headline>

                    {props.data.preamble && props.data.preamble.length > 0 &&
                        <P preamble={!isMobile}>{props.data.preamble}</P>
                    }

                    {(!props.data.preamble || props.data.preamble.length === 0) &&
                        <React.Fragment>
                            {props.data.bulletListIntro && props.data.bulletListIntro.length > 0 &&
                                <P preamble={!isMobile}>{props.data.bulletListIntro}</P>
                            }
                            <ul>
                                {props.data.bulletList && props.data.bulletList.map((bullet, index) => (
                                    <li key={`bullet-${index}`}><Icon name="check-circle" size={32} />{bullet}</li>
                                ))}
                            </ul>
                        </React.Fragment>
                    }

                    {props.data.buttonLink && 
                        <ButtonLink 
                            href={props.data.buttonLink}
                            forceExternal={isExternalUrl(props.data.buttonLink)} 
                            buttonColor={ButtonColor.CTA} 
                            buttonSize={ButtonSize.DEFAULT} 
                            buttonType={ButtonType.DEFAULT} 
                        >
                            {props.data.buttonText ?
                                props.data.buttonText :
                                <FormattedMessage id="jm.components.organisms.ctaHeaderBlock.readMore" />
                            }
                        </ButtonLink>
                    }
                </div>
            }
        </div>
    );
};

